import {
  AfterViewInit,
  Component,
  HostBinding,
  Input,
  inject,
} from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { LoaderIndicatorDirective, LoaderService } from '@t-llevo/common-ui';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 't-llevo-summary-card-item',
  standalone: true,
  imports: [AsyncPipe, MatIconModule, LoaderIndicatorDirective],
  styleUrl: './summary-card-item.component.scss',
  providers: [LoaderService],
  template: `
    <div commonui-loader [appLoader]="loading() ?? false" class="h-100">
      <header class="title h-50 d-flex justify-content-center">
        {{ cardTitle }}
      </header>
      <div class="value">
        {{ (value$ | async) || '0' }}
      </div>
      <mat-icon
        [svgIcon]="svgIcon"
        [style.fill]="svgColor"
        aria-hidden="true"
      ></mat-icon>
    </div>
  `
})
export class SummaryCardItemComponent implements AfterViewInit {
  @Input() bgColor = '#FFF';
  @Input() fontColor = '#000';
  @Input() cardTitle = 'Example title';
  @Input() svgIcon = 'account';
  @Input() svgColor = '#000';
  @Input() value!: Observable<number | null>;

  @HostBinding('style.background-color') get styleBackgroundColor() {
    return this.bgColor;
  }

  @HostBinding('style.color') get styleColor() {
    return this.fontColor;
  }

  private loaderSrv = inject(LoaderService);
  loading = toSignal(this.loaderSrv.loaderState$);

  private valueSubject = new BehaviorSubject<number | null>(null);
  value$ = this.valueSubject.asObservable();

  constructor() {
    this.value$.subscribe((data) => {
      if (data || data === 0) {
        this.loaderSrv.hide();
      } else {
        this.loaderSrv.show();
      }
    });
  }

  ngAfterViewInit(): void {
    this.value.subscribe((data) => {
      if (data || data === 0) {
        this.valueSubject.next(data);
      }
    });
  }
}
